import { render, staticRenderFns } from "./PasswordSetFields.vue?vue&type=template&id=d83c97be&"
import script from "./PasswordSetFields.vue?vue&type=script&lang=js&"
export * from "./PasswordSetFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VExpandTransition,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d83c97be')) {
      api.createRecord('d83c97be', component.options)
    } else {
      api.reload('d83c97be', component.options)
    }
    module.hot.accept("./PasswordSetFields.vue?vue&type=template&id=d83c97be&", function () {
      api.rerender('d83c97be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/PasswordSetFields.vue"
export default component.exports